import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import svgEyeOpen from '../../svgs/View_default.svg';
import svgEyeClosed from '../../svgs/View_off_default.svg';
import filter from "../../filter";
import { executeQuery } from "../../requests/executeQuery";
import dollars from "../../dollar-format";
import { addSpaceAfterComma } from '../../utils';
import { BUYERS_LIST, BUYERS_LIST_COUNT } from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_BUYERS } from '../Graphql/Queries/BuyersQuery';
import { fetchData } from '../Service/graphQlService';
import { GET_BUYER_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';

let cloneDeep = require('lodash.clonedeep');
let find = require('lodash.find');

const limit = 50;
const defaultSubcatNo = 3;

export default class BuyerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
        this.client = null

        this.expandRow = this.expandRow.bind(this);
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
        }
    }
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }


    fetch(q) {
        this.setState({ isBusy: true });
        const query = { ...q };
        if (!this.props.isSuper && !query.STATUS) {
            query.STATUS = '1031-Buyer,Active';
        }
        const options = filter(query, 'buyers');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize:limit
        }

        // Promise.all([
        //     executeQuery({ queryName: BUYERS_LIST, options: options }),
        //     executeQuery({ queryName: BUYERS_LIST_COUNT, options: options })
        // ]).then(res => {
        //     const items = res[0].data.map(el => {
        //         el.IS_EXPANDED = false;
        //         return el;
        //     });
        //     this.setState({
        //         items,
        //         totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
        //         error: res[0].success ? null : res[0].message,
        //         isBusy: null,
        //     });
        // });
        const token = localStorage.getItem('authToken');
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 
        // if (this.client) {
            
        //     this.client.query({ query: GET_BUYERS, variables: {pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions},fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     }})
        //         .then(res => {
        //             const items = res.data.getBuyers.buyer.map((el, index) =>{
        //                 // el.IS_EXPANDED = false;
        //                 // return el;
        //                 return { ...el, is_expanded: false };
        //             })
        //             this.setState({
        //                 items: items,
        //                 totalCount: res.data.getBuyers.totalCount,
        //                 error: null,
        //                 isBusy: null,
        //             });
        //         })
        //         .catch(err => {
        //             this.setState({
        //                 error: err.message,
        //                 isBusy: null,
        //             });
        //         });
        // }
        if (this.client) {
            // Use fetchData service to fetch the data
            // fetchData(GET_BUYER_LIST_QUERY, {type:"Buyer",pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions })
            // .then(res => {
            //     const items = res.data.getContacts.data.map((el) => {
            fetchData(GET_BUYER_LIST_QUERY, {type:"Buyer",pageOptions: pageParams, filters: filterOptions, sortOptions: sortOptions })
                .then(res => {
                    const items = res.data.getContacts.data.map((el) => {
                        return { ...el, is_expanded: false };
                    });
    
                    this.setState({
                        items: items,
                        totalCount: res.data.getContacts.totalCount,
                        error: null,
                        isBusy: null,
                    });
                })
                .catch(err => {
                    this.setState({
                        error: err.message,
                        isBusy: null,
                    });
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    expandRow(el) {
        const items = cloneDeep(this.state.items);
        const item = find(items, { arcimedes_row_id: el.arcimedes_row_id });
        item.is_expanded = !item.is_expanded;
        this.setState({ items });
    }

    render() {
        const query = this.props.location.query;
        const columns = [{
            name: 'View',
            textAlign: 'center',
            columnStyle: {
                width: 70
            },
            render: (el) => {
                if (this.props.isSuper)
                    // return <Link to={{ pathname: `${arc.path.base}buyer/${el.arcimedes_row_id}` }}><Icon svg={svgEdit} /></Link>
                    return <Link to={{ pathname: `${arc.path.base}buyer/${el.contact_id}`, state: { fromListUrl: window.location.pathname + window.location.search } }}><Icon svg={svgEdit} /></Link>
                return <div className='icon-normal' style={{ cursor: 'pointer' }} onClick={() => this.expandRow(el)}><Icon svg={el.is_expanded ? svgEyeClosed : svgEyeOpen} /></div>
            },
        },];

        if (!this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.strive_agent_last_name,
            },)
        }

        columns.push({
            code: 'STATUS',
            name: 'Status',
            render: (el) => el.status,
        }, {
            code: 'CATEGORY',
            name: 'Category',
            render: (el) => el.category ? addSpaceAfterComma(el.category) : '',
        }, {
            code: 'TYPE',
            name: 'Type',
            render: (el) => el.type ? addSpaceAfterComma(el.type) : '',
        }, {
            code: query.type === 'MT' ? 'multi_tenant_subcategory' : 'single_tenant_subcategory',
            name: 'Subcategory',
            render: (el) => {
                let value = '';
                if (el.type === 'MT' && el.multi_tenant_subcategory)
                    value = addSpaceAfterComma(el.multi_tenant_subcategory);
                if (el.type === 'STNL' && el.single_tenant_subcategory)
                    value = addSpaceAfterComma(el.single_tenant_subcategory);
                if (!el.is_expanded && (value.match(/,/g) || []).length > defaultSubcatNo - 1)
                    return `${value.split(',', defaultSubcatNo).join()}...`;
                return value;
            }
        }, {
            code: 'MARKET',
            name: 'Market',
            render: (el) => el.market ? addSpaceAfterComma(el.market) : '',
        }, {
            name: 'Price',
            subColumns: [{
                code: 'PRICE_MIN',
                name: 'Min',
                textAlign: 'right',
                render: (el) => el.price_min ? dollars(el.price_min) : ''
            }, {
                code: 'PRICE_MAX',
                name: 'Max',
                textAlign: 'right',
                render: (el) => el.price_max ? dollars(el.price_max) : ''
            }],
            headerStyle: {
                minWidth: 130,
                justifyContent: 'center',
            },
            render: () => '',
        }, {
            name: 'Cap Rate',
            subColumns: [{
                code: 'CAP_RATE_MIN',
                name: 'Min',
                textAlign: 'right',
                render: (el) => el.cap_rate_min ? `${el.cap_rate_min}%` : ''
            }, {
                code: 'CAP_RATE_MAX',
                name: 'Max',
                textAlign: 'right',
                render: (el) => el.cap_rate_max ? `${el.cap_rate_max}%` : ''
            }],
            headerStyle: {
                minWidth: 80,
                justifyContent: 'center',
            },
            render: () => '',
        }, {
            name: 'Buyer',
            subColumns: [{
                code: 'FIRST_NAME',
                name: 'First Name',
                render: (el) => el.first_name,
            }, {
                code: 'LAST_NAME',
                name: 'Last Name',
                render: (el) => el.last_name,
            }],
            headerStyle: {
                minWidth: 218,
                justifyContent: 'center'
            },
        }, {
            code: 'EMAIL',
            name: 'Email',
            render: (el) => el.email ? <a href={`mailto:${el.email}`}>{el.email}</a> : null,
        }, {
            code: 'PHONE',
            name: 'Phone',
            columnStyle: {
                minWidth: 132,
            },
            render: (el) => el.phone ?
                <a href={`tel:${el.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.phone}</a> : null,
        }, {
            code: 'COMPANY_NAME',
            name: 'Company Name',
            render: (el) => el.company_name,
        });

        if (this.props.isSuper) {
            columns.push({
                code: 'STRIVE_AGENT_LAST_NAME',
                name: 'Agent',
                render: (el) => el.strive_agent_last_name,
            })
        }

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                        // this.fetch(this.props.location.query);
                    }
                    return (
                        <div className='BuyerList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Buyers</div>
                                        <LinkComp to={`${arc.path.base}buyer`}>
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={columns}
                                    classNameModifier={this.props.isSuper ? 'buyers-admin' : 'buyers-agent'}
                                    items={this.state.items}
                                    query={query}
                                    hasSubColumns={true}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                    className="buyer"
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}
